import React from 'react'

const About = () => {
  return (
    <div name="about" 
    className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-5">
        I'm Atahan. I graduated from Istanbul Medipol University Computer Engineering. 
        I am currently working as a Software Engineer at Geovision Group. I am involved in various projects both internally and as an outsourced . 
        I skilled in using technologies such as C#, Javascript, Linq, Entity Framework, ASP.NET MVC. 
        Outside of software development, I take pleasure in playing video games and watching movies.
        </p>

      </div>
    </div>
  )
}

export default About